import { Sprint, RawSprint } from '../pages/YourTeams/types';

import { supabase } from './supabase';

const standardizeDate = (dateString: string | null): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  date.setHours(0, 0, 0, 0);
  return date.toString();
};

export async function fetchTeamSprints(
  teamId?: string | null,
): Promise<Sprint[]> {
  if (!teamId) {
    return [];
  }

  const { data, error } = await supabase
    .from('sprints')
    .select('*')
    .eq('team_id', teamId)
    .order('start_date', { ascending: false });

  if (error) {
    throw new Error(`Failed to fetch sprints: ${error.message}`);
  }

  return (data || []).map((sprint: RawSprint) => ({
    id: sprint.id,
    name: sprint.name,
    startDate: standardizeDate(sprint.start_date),
    endDate: standardizeDate(sprint.end_date),
    status: sprint.status,
  }));
}
